module.exports = __webpack_public_path__ + "7c97110bd0c0f738e0f9d99f502218d6.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/commers.png
// module id = 594
// module chunks = 0